import React from "react";
import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
import { HomeContainer } from "./home/home-container.component";
import { ContainerComponent } from "./container.component";
import { data } from "./data";
import { IndexServicePage } from "./service/pages/index-service.page";
import { ServicePage } from "./service/pages/service.page";
import { TermsAndConditions } from "./footer/components/terms-and-contitions.component";
import { PrivacyPolicy } from "./footer/components/privacy-policy.component";
import RemoveTrailingSlash from "./components/remove-trailing-slash.component";

function App() {
    return (
        <>
            <RemoveTrailingSlash />
            <Routes>
                <Route path="/" element={<ContainerComponent />}>
                    <Route
                        index
                        element={<Navigate to={data.routes.home} replace />}
                    />
                    <Route
                        path={data.routes.home}
                        element={<HomeContainer />}
                    />
                    <Route
                        path={data.routes.termsAndConditions}
                        element={<TermsAndConditions />}
                    />
                    <Route
                        path={data.routes.privacyPolicy}
                        element={<PrivacyPolicy />}
                    />

                    <Route
                        path="/services/:service"
                        element={<IndexServicePage />}
                    />
                    <Route
                        path="/services/:iserviceid/:serviceid"
                        element={<ServicePage />}
                    />
                </Route>
            </Routes>
        </>
    );
}

export default App;
